import React from 'react';

import DragHotspot from 'components/DragHotspot';
import styles from './styles.module.scss';

interface Props {
  position: number;
}

const LayoutDragHotspot: React.FC<Props> = ({ position }) => (
  <div
    className={styles.layoutDragHotspot}
    style={{ order: position }}
  >
    <DragHotspot />
  </div>
);

export default LayoutDragHotspot;
